<template>

  <section>
    <h2 class="title mb-2 mt-5">Receipt Details</h2>
    <v-menu
      ref="menu1"
      v-model="datemenu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="dateFormatted"
          label="Date"
          hint="MM/DD/YYYY format"
          persistent-hint
          prepend-icon="event"
          @blur="form.date = parseDate(dateFormatted)"
          v-on="on"
          outlined
        ></v-text-field>
      </template>
      <v-date-picker v-model="form.date" no-title @input="datemenu = false"></v-date-picker>
    </v-menu>
    <v-card class="my-5">
      <v-simple-table class="form-table">
        <template v-slot:default>
          <thead>
            <tr>
              <th>Item</th>
              <th>Description</th>
              <th>Rate</th>
              <th>Value</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="form.miles"> 
              <td> Miles </td>
              <td>
                <v-text-field
                  v-model="form.miles.description"
                  placeholder="Add Description"
                  dense
                  solo 
                  flat
                  hide-details
                ></v-text-field>
              </td>
              <td></td>
              <td>
                <v-text-field
                  v-model="form.miles.value"
                  placeholder="Add Item Value"
                  dense
                  solo 
                  flat
                  hide-details
                ></v-text-field>
              </td>
              <td class="actions-cell"></td>
            </tr>
            <tr v-if="form.warranty">
              <td> Waranty </td>
              <td>
                <v-text-field
                  v-model="form.warranty.description"
                  placeholder="Add Description"
                  dense
                  solo 
                  flat
                  hide-details
                ></v-text-field>
              </td>
              <td>  </td>
              <td>
                <v-select
                  :items="warrantyOptions"
                  v-model="form.warranty.value"
                  placeholder="Select a Waranty"
                  dense
                  solo 
                  flat
                  hide-details
                ></v-select>
              </td>
              <td class="actions-cell"></td>
            </tr>
            <tr v-for="(item, i) in form.items" :key="`formitems-${i}`">
              <td> 
                <v-select
                  :items="itemOptions"
                  v-model="item.type"
                  placeholder="Select a Waranty"
                  dense
                  solo 
                  flat
                  hide-details
                ></v-select>  
              </td>
              <td>
                <v-text-field
                  v-model="item.description"
                  placeholder="Add Description"
                  dense
                  solo 
                  flat
                  hide-details
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  v-model="taxRate"
                  dense
                  solo 
                  flat
                  hide-details
                  v-if="item.type === 'tax'"
                ></v-text-field>
                <v-text-field
                  value="1"
                  dense
                  solo 
                  flat
                  hide-details
                  v-else
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  v-model="item.value"
                  placeholder="Add Value"
                  dense
                  solo 
                  flat
                  hide-details
                  @keyup="updateTax(item)"
                ></v-text-field>
              </td>
              <td class="actions-cell">
                <v-btn icon color="success" @click="addItem()"><v-icon>add</v-icon></v-btn> 
                <v-btn icon color="warning" @click="removeItem(i)"><v-icon>remove</v-icon></v-btn> 
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

    </v-card>
  </section>
</template>

<script>
import { getOfficeTaxRate } from "../../utils/officeLocation";

const defaultItem = { type: '', description: '', value: '' };

export default {
  name: "ReceiptDetails",
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    warrantyOptions: {
      type: Array,
      default: () => ([])
    },
    itemOptions: {
      type: Array,
      default: () => ([])
    }
  },
  data: (vm) => ({
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    datemenu: false,
    taxRate: "",
  }),
  watch: {
    form:{
      handler() {
        this.dateFormatted = this.formatDate(this.form.date);
      },
      deep: true
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    updateTax() {
      let totalParts = 0;
      let totalLabour = 0;
      let totalInstallation = 0;
      let fee = 0;
			this.form.items.forEach((item) => {
				if (item.type === "part") {
					totalParts += parseFloat(item.value) || 0;
				}
        if (item.type === "labour") {
					totalLabour += parseFloat(item.value) || 0;
				}
        if (item.type === "installation") {
					totalInstallation += parseFloat(item.value) || 0;
				}
			});

			if (totalParts > 0) {
				// todo add cc fee
				const taxRate = this.taxRate / 100;
				var val = totalParts;
        var labourfee = totalLabour;
        var installationfee = totalInstallation;
        var TotalRate = val + labourfee + installationfee;
        if (this.selectedLocation === 'WA') {
          fee = parseFloat((TotalRate * taxRate).toFixed(2));
        } else {
          fee = parseFloat((val * taxRate).toFixed(2));
        }

				var taxExist = false;
				var emptyItem = null;
				const tax = {...defaultItem};
				tax.type = "tax";

        if(this.selectedLocation === 'WA'){
          tax.description = "Tax added for Parts " + val + " + installation "+ installationfee +" + labour " + labourfee;
        }else{
          tax.description = "Tax added for Parts " + val;
        }
        

			//	tax.description = "Tax added for Parts " + val;
        
				tax.value = fee;
				this.form.items.forEach((item, i) => {
					if (item.type === 'tax') {
						taxExist = true;
						this.form.items.splice(i, 1,tax)
					} else if (emptyItem === null && (!item.type || item.type === '')) {
						emptyItem = i;
					}
				});
				if (!taxExist) {
					// todo add cc fee
					if (emptyItem != null) {
            this.form.items.splice(emptyItem, 1,tax);
					} else {
						this.form.items.push(tax);
					}
				}
			}
    },
    addItem() {
			this.form.items.push({...defaultItem});
		},
		removeItem(i) {
			// this.form.items.splice(i, 1);
			if (this.form.items.length === 1) {
				this.form.items = [{...defaultItem}];
			} else {
				this.form.items.splice(i, 1);
			}
		}
  },
  async mounted() {
    const location = this.selectedLocation;
    this.taxRate = await getOfficeTaxRate(location);
  }
};
</script>